import React, { useContext } from 'react';

// Components
import InboxConversationList from './InboxConversationList';
import ConversationSearch from './ConversationSearch';
import ConversationWindow from './ConversationWindow';
import MessageInput from './MessageInput';
import {
    InboxContainerStyled,
    SidebarStyled,
    ContainerMainStyled,
    ContainerMainInnerStyled,
    ConversationSearchContainerStyled,
} from './MessagesInboxStyles';

import LoadingArea from '@molecules/LoadingArea';

// Functionality
import ConversationParticipantsProvider from './providers/ConversationParticipantsProvider';
import ConversationSearchProvider from './providers/ConversationSearchProvider';
import { InboxReadyContext } from './providers/InboxReadyProvider';

const MessagesInboxReady = () => {
    const { isInboxReady } = useContext(InboxReadyContext);

    return (
        <div style={{ position: 'relative' }}>
            {!isInboxReady && <LoadingArea minHeight={620} style={{ position: 'absolute' }} />}
            <InboxContainerStyled className="fade-in-fast">
                <ConversationParticipantsProvider>
                    <SidebarStyled>
                        <ConversationSearchProvider>
                            <ConversationSearchContainerStyled>
                                <ConversationSearch />
                            </ConversationSearchContainerStyled>
                            <InboxConversationList />
                        </ConversationSearchProvider>
                    </SidebarStyled>
                    <ContainerMainStyled>
                        <ContainerMainInnerStyled>
                            <ConversationWindow />
                            <MessageInput />
                        </ContainerMainInnerStyled>
                    </ContainerMainStyled>
                </ConversationParticipantsProvider>
            </InboxContainerStyled>
        </div>
    );
};

export default MessagesInboxReady;
